import { languageSelector } from '../../selectors/app';
import { RootState } from '../../reducers';
import { featureFlagsSelector } from 'shared/selectors/config';

export const selector = (state: RootState) => ({
  language: languageSelector(state),
  newLangEs: featureFlagsSelector(state).newLangEs,
});
